import { TOKEN_CAPTCHA_COOKIE_KEY, checkCookie, setCookie } from '../../utils/cookiesUtil';
import Cookies from 'js-cookie';
const { REACT_APP_LIFERAY_API = window.location.origin } = process.env;


export const getLiferayAuthenticationToken = () => {
	try {
		// eslint-disable-next-line no-undef
		const token = Liferay.authToken;

		return token;
	} catch (error) {
		console.warn('Not able to find Liferay auth token\n', error);

		return '';
	}
};

const baseFetch = async (url, { accessToken, body, method = 'GET' } = {}) => {
    let headersContent = {};
    const captchaToken = checkCookie(TOKEN_CAPTCHA_COOKIE_KEY);
    const cgex = Cookies.get('cgex'); // <-- lee la cookie 'cgex' (userId:companyId)

    headersContent = {
        'Content-Type': 'application/json',
        'x-csrf-token': getLiferayAuthenticationToken(),
        ...(accessToken && { 'x-api-auth': accessToken }),
        ...(captchaToken && { 'g-recaptcha-response': captchaToken }),
        ...(cgex && { 'X-CGEX': cgex }), // <-- agrega header custom si existe cookie
        'X-Client': 'react-app',
        'App-Source': 'react-app'
    };

    try {
        const response = await fetch(url, {
            ...(body && { body: JSON.stringify(body) }),
            headers: headersContent,
            mode: 'cors',
            method,
        });

        try {
            const data = await response.json();
            return { data, response };
        } catch (err) {
            const data = await response;
            return { data };
        }
    } catch (erro) {
        return {};
    }
};

const baseFetchDoc = async (url, { accessToken, auxFormData, body, method = 'GET' } = {}) => {

	let headersContent = {};
	const captchaToken = checkCookie(TOKEN_CAPTCHA_COOKIE_KEY);


	headersContent = {
		'Content-Type': 'arraybuffer',
		'x-csrf-token': getLiferayAuthenticationToken(),
		...(accessToken && { 'x-api-auth': accessToken }),
		...(captchaToken && { 'g-recaptcha-response': captchaToken }),
		'X-Client': 'react-app',
		'App-Source': 'react-app'
	};

	const response = await fetch(url + "?json=" + encodeURI(JSON.stringify(body)), {
		headers: headersContent,
		mode: 'cors',
		method,
		body: auxFormData
	});
	try {
		if (response?.status === 200) {
			setCookie(TOKEN_CAPTCHA_COOKIE_KEY, "");
			return response.arrayBuffer();
		} else {
			return response.json();
		}
	} catch (err) {
		const data = await response;
		return { data };
	}

};

const baseFetchDocJson = async (url, { accessToken, auxFormData, body, method = 'GET' } = {}) => {


	let headersContent = {};
	const captchaToken = checkCookie(TOKEN_CAPTCHA_COOKIE_KEY);


	headersContent = {
		'x-csrf-token': getLiferayAuthenticationToken(),
		...(accessToken && { 'x-api-auth': accessToken }),
		...(captchaToken && { 'g-recaptcha-response': captchaToken }),
		'X-Client': 'react-app',
		'App-Source': 'react-app'
	};

	const response = await fetch(url + "?json=" + encodeURI(JSON.stringify(body)), {
		headers: headersContent,
		mode: 'cors',
		method,
		body: auxFormData
	});
	try {
		const data = await response.json();
		return { data };
	} catch (err) {
		const data = await response;
		return { data };
	}

};

const baseFetchPDF = async (url, { accessToken, body, shouldSendFilename = false, method = 'GET' } = {}) => {

	let headersContent = {};
	const captchaToken = checkCookie(TOKEN_CAPTCHA_COOKIE_KEY);

	headersContent = {
		'Content-Type': 'application/json',
		'responseType': 'arraybuffer',
		'x-csrf-token': getLiferayAuthenticationToken(),
		...(accessToken && { 'x-api-auth': accessToken }),
		...(captchaToken && { 'g-recaptcha-response': captchaToken }),
		'X-Client': 'react-app',
		'App-Source': 'react-app'
	};

	const response = await fetch(url, {
		...(body && { body: JSON.stringify(body) }),
		headers: headersContent,
		mode: 'cors',
		method,
	});
	try {
		if (response?.status === 200) {
			const filename = decodeURIComponent(response.headers.get('Content-Disposition').split('filename=')[1]);
			const buffer = await response.arrayBuffer();


			if (shouldSendFilename) {
				return { buffer, filename };
			} else {
				return buffer;
			}
		} else {
			return response.json();
		}
	} catch (err) {
		const data = await response;
		return { data };
	}
};

const baseFetchWebContent = async (url, { accessToken, body, method = 'GET' } = {}) => {

	let headersContent = {};
	const captchaToken = checkCookie(TOKEN_CAPTCHA_COOKIE_KEY);

	headersContent = {
		'Content-Type': 'application/json;',
		'x-csrf-token': getLiferayAuthenticationToken(),
		...(accessToken && { 'x-api-auth': accessToken }),
		...(captchaToken && { 'g-recaptcha-response': captchaToken }),
		'X-Client': 'react-app',
		'App-Source': 'react-app'
	};

	const response = await fetch(url, {
		...(body && { body: JSON.stringify(body) }),
		headers: headersContent,
		mode: 'cors',
		method,
	});

	try {
		const data = await response.text();
		return { data };
	} catch (err) {
		const data = await response;
		return { data };
	}
};

const LiferayFetchAPI = {
	delete: (url, options) => baseFetch(url, { ...options, method: 'DELETE' }),
	get: (url, options) => baseFetch(url, { ...options }),
	patch: (url, options) => baseFetch(url, { ...options, method: 'PATCH' }),
	post: (url, options) => baseFetch(url, { ...options, method: 'POST' }),
	postDoc: (url, options) => baseFetchDoc(url, { ...options, method: 'POST' }),
	postDocJson: (url, options) => baseFetchDocJson(url, { ...options, method: 'POST' }),
	postPDF: (url, options) => baseFetchPDF(url, { ...options, method: 'POST' }),
	postWebContent: (url, options) => baseFetchWebContent(url, { ...options, method: 'POST' }),
	put: (url, options) => baseFetch(url, { ...options, method: 'PUT' }),
};
export { REACT_APP_LIFERAY_API };

export default LiferayFetchAPI;
